import { z } from 'zod'
import { UTCMillisecondsSchema } from '../time'

export const AreaJobStatusSchema = z.enum(['preparing', 'queued', 'running', 'completed'])
export type AreaJobStatus = z.infer<typeof AreaJobStatusSchema>

export const AreaJobInfoSchema = z.object({
  total: z.number(),
  assigned: z.number(),
  assignedDate: UTCMillisecondsSchema,
  isRunning: z.boolean(),
  status: AreaJobStatusSchema,
})
export type AreaJobInfo = z.infer<typeof AreaJobInfoSchema>
